import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useUpdateUserQuery, useUsersMapQuery } from 'queries/members';
import { useManagerOfUsers } from '../../people-list/hooks/use-manager-of';
import { OrgNode } from '../types';
import { PeopleEditor } from './PeopleEditor';

interface Props {
  userId: number;
  onComplete: any;

  selected: OrgNode[];
}

export const EditNodeAddReportees = (props: Props) => {
  const { selected, onComplete, userId } = props;
  const { data: users, isLoading } = useManagerOfUsers(userId);
  const { data: userMap } = useUsersMapQuery();
  const { mutate } = useUpdateUserQuery();

  const onCompleteWithUpdate = (selectedValues) => {
    const user = userMap?.get(userId);

    if (user) {
      user.managerOf = selectedValues.map((s) => s.userId);
      mutate(user);
    }
    onComplete();
  };

  return (
    <PeopleEditor
      title={<FormattedMessage id="customer_company.fields.manager_of" />}
      selected={selected.map((node) => node.user)}
      users={users}
      onComplete={onCompleteWithUpdate}
      isLoading={isLoading}
      stopPropogation
      isMulti
    />
  );
};
